import type { PlaywireAd } from '@creator/sdk/modules/config/config.model';
import { getActiveAdProvider, getPlaywireAd } from '@src/model/config/helpers';
import { useMemo } from 'react';

export type Ad = PlaywireAd;

function useAd(location: string, tokenName: string, playWireLocation?: string) {
    const provider = getActiveAdProvider();
    const ad = useMemo(() => {
        if (!provider) return;
        if (provider === 'playwire') return getPlaywireAd(playWireLocation || location);
    }, [provider, tokenName, location]);

    // compute the style from ad.sizes
    const sizeStyle = useMemo(() => {
        if (!ad) return {};

        const sizes = ad.sizes as number[] | number[][];
        if (!Array.isArray(sizes[0])) {
            // sizes is a single array of two numbers
            const [width, height] = sizes as number[];
            return { minWidth: width, minHeight: height };
        }
        // sizes is an array of arrays; calculate the minimum width and maximum height
        const minWidth = Math.min(...sizes.map(size => size[0]));
        const minHeight = Math.max(...sizes.map(size => size[1]));
        return { minWidth, minHeight };
    }, [ad]);

    return { ad, provider, sizeStyle };
}

export default useAd;
